module.exports = __webpack_public_path__ + "static/img/LOADING-2026.da241c8.gif";


//////////////////
// WEBPACK FOOTER
// ./static/gifs/LOADING-2026.gif
// module id = 318
// module chunks = 1